import React, { useEffect } from 'react';
import { Modal, Form, Input, Switch, Select, Button, message } from 'antd';
import { customBaseUrl, httpPut } from '../../store/http';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';

const { Option } = Select;
const { TextArea } = Input;

const EditProductModal = ({ showModal, hideModal, reloadProducts, product }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (product) {
      form.setFieldsValue(product);
      form.setFieldsValue({
        isActive: product.active,
      });
    }
  }, [product, form]);

  const onFinish = async (values) => {
    showLoader();
    try {
      const payload = {
        ...values,
        status: values.status || 'ACTIVE',
        isActive: values.isActive !== undefined ? values.isActive : true,
      };
      const response = await httpPut(`${customBaseUrl.integUrl}/api/v1/products/${product.productCode}`, payload);
      if (response.status) {
        message.success('Product updated successfully');
        hideModal();
        reloadProducts();
      } else {
        Swal.fire('Error', response.message || 'Failed to update product', 'error');
      }
    } catch (error) {
      console.error('Error updating product:', error);
      Swal.fire('Error', 'An error occurred while updating product', 'error');
    } finally {
      hideLoader();
    }
  };

  return (
    <Modal
      title="Edit Product"
      open={showModal}
      onCancel={hideModal}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="productName"
          label="Product Name"
          rules={[{ required: true, message: 'Please enter product name' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please enter product description' }]}
        >
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: 'Please select a status' }]}
        >
          <Select>
            <Option value="ACTIVE">ACTIVE</Option>
            <Option value="INACTIVE">INACTIVE</Option>
            <Option value="PENDING">PENDING</Option>
          </Select>
        </Form.Item>
        <Form.Item name="isActive" label="Is Active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Update Product
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditProductModal;
